import {
  Component,
  OnInit,
  ElementRef,
  Output,
  ViewChild,
  EventEmitter,
  ChangeDetectorRef,
  Input,
  Inject
} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { CommonService } from '../../_services/common.service';
import { SharedService } from '../../_shared/shared.service';
import { MetaDataService } from '../../features/metaData/Uploader/metaData-uploader.service'
import * as globals from '../../_shared/globals';

// import { ValidationService } from '../../../_services/validation.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-metadata',
  templateUrl: './metadata.component.html',
  styleUrl: './metadata.component.scss'
})
// export class MetadataComponent {

// }



export class MetadataComponent implements OnInit {
  @Output() response: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('imgfile') imgfile!: ElementRef;
  @ViewChild('input', { static: true }) fileInput!: ElementRef;
  optaId = ''
  matchId = ''
  isMetaDataAvailable: Boolean = false
  assetsId:any
  matchName = ''
  club = ''
  metaDataForm!: FormGroup;

  selectedLogo: any = 'assets/images/edit-profile-pic.png';
  submitted = false;

  isPushedOnLvs: boolean = false;
  isActive: boolean = false;
  option: any = {};
  isSubmitting = false;



  constructor(
  public dialogRef: MatDialogRef<MetadataComponent>, // ✅ Fix here
  @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private formBuilder: FormBuilder,

    private metaDataService: MetaDataService,
    private http: HttpClient
  ) {
    // this.createMetaDataForm(this.option);
    // this.initForm(this.option);
  }

  ngOnInit() {
        this.createMetaDataForm(this.option);
      this.response = new EventEmitter();

      // ✅ Fix: Assign incoming data to component properties
      this.matchId = this.data.matchId;
      this.assetsId = this.data.assetsId;
      this.isMetaDataAvailable = this.data.isMetaDataAvailable;
      this.matchName = this.data.matchName;
      this.club = this.data.club;

      // ✅ Fetch existing metadata if available
      if (this.matchId && this.isMetaDataAvailable) {
        this.metaDataService.getOptaDetail(this.matchId).subscribe({
         next: (res: any) => {
            if (res && res.success) {
              this.createMetaDataForm(res.data);
              this.isActive = res.data.status === 'Active';
              this.isPushedOnLvs = res.data.isPushedOnLvs === true;
              this.optaId = res.data._id;
            }
          },
          error:(error: any) => {
            console.log(error,"errorro mili  hai")
            this.commonService.showError('', error.error.message);
          }
      });
      }
}


  toggleStatus() {

    this.isActive = !this.isActive;
  }

  toggleMe() {

    this.isPushedOnLvs = !this.isPushedOnLvs;


  }

  convToSec(hms:any) {
    let timeStamp = hms.toString()
    let seconds;
    if (timeStamp.includes(':')) {
      var time = timeStamp.split(':');
      if (time.length != 3 || !time) {
        alert('Please enter time in HH:MM:SS format')
      }
      seconds = (+time[0]) * 60 * 60 + (+time[1]) * 60 + (+time[2]);
    } else if (this.matchId && this.isMetaDataAvailable) {
      seconds = +hms;
    } else {
      seconds = +hms;
    }
    return seconds
  }

  videoCreate(manageCatForm: FormGroup) {
      if (this.isSubmitting) {
    return; 
  }

  this.isSubmitting = true;
    this.submitted = true;
    this.metaDataForm.value.assetsId = this.assetsId;
    this.metaDataForm.value.matchId = this.matchId;
    this.metaDataForm.value.matchName = this.matchName;
    this.metaDataForm.value.clubId = this.club;
    if (manageCatForm.invalid) {
      this.isSubmitting = false;
      return ;
    }

    if (this.isActive) {
      this.metaDataForm.value.status = 'Active'
      this.metaDataForm.value.isPasswordSet = true
    } else {
      this.metaDataForm.value.status = 'In Active'
    }

    if (this.isPushedOnLvs) {
      this.metaDataForm.value.isPushedOnLvs = true

    } else {
      this.metaDataForm.value.isPushedOnLvs = false
    }
    this.metaDataForm.value.startTime = this.convToSec(this.metaDataForm.value.startTime)
    this.metaDataForm.value.endTime = this.convToSec(this.metaDataForm.value.endTime)
    this.metaDataForm.value.secondStart = this.convToSec(this.metaDataForm.value.secondStart)
 if (this.matchId && this.isMetaDataAvailable) {
    this.metaDataService.updateOpta(this.optaId, manageCatForm.value).subscribe({
      next: (res: any) => {
        this.isSubmitting = false; 

        if (res && res.success) {
          this.dialogRef.close({ success: true });
        } else {
          this.commonService.showError('', res.message);
        }
      },
      error: (err) => {
        this.isSubmitting = false; 
        this.commonService.showError('', err.error ? err.error.message : err);
      }
    });
  } else {
    this.metaDataService.createOpta(manageCatForm.value).subscribe({
      next: (res: any) => {
        this.isSubmitting = false;

        if (res && res.success) {
          this.updatemyMatchStatus(this.matchId)
        } else {
          this.commonService.showError('', res.message);
        }
      },
      error: (err) => {
        this.isSubmitting = false; 
        this.commonService.showError('', err.error ? err.error.message : err);
      }
    });
  }

    // if (this.matchId && this.isMetaDataAvailable) {
    //   this.metaDataService.updateOpta(this.optaId, manageCatForm.value).subscribe({
    // next:    (res: any) => {
    //       if (res && res.success) {
    //         // this.response.emit(res);
    //         this.dialogRef.close({ success: true });
    //       } else {
    //         this.commonService.showError('', res.message);
    //       }
    //     },
    //   error:  (err) => {
    //       this.commonService.showError('', err.error ? err.error.message : err);
    //     }
    //  } );
    // } else {
    //   this.metaDataService.createOpta(manageCatForm.value).subscribe({
    //   next:  (res: any) => {
    //       if (res && res.success) {
    //         this.updatemyMatchStatus(this.matchId)
    //         // this.response.emit(res);
    //       } else {
    //         this.commonService.showError('', res.message);
    //       }
    //     },
    //   error:  (err) => {
    //       this.commonService.showError('', err.error ? err.error.message : err);
    //     }
    // });
    // }
  }

  


  private createMetaDataForm(values: any) {


    this.metaDataForm = this.formBuilder.group({

      // assetsId: [values.assetsId ? values.assetsId : null, Validators.required],
      startTime: [values.startTime ? values.startTime : null, Validators.required],

      endTime: [values.endTime ? values.endTime : null, Validators.required],

      secondStart: [values.secondStart ? values.secondStart : null, Validators.required],

      f24Url: [values.f24Url ? values.f24Url : null, [Validators.required,Validators.pattern(/^https:\/\/.+$/) ]],

      f40Url: [values.f40Url ? values.f40Url : null,[Validators.required,Validators.pattern(/^https:\/\/.+$/) ]],

      // club: [values.club ? values.club : null, Validators.required],

      status: [this.isActive ? 'Active' : 'In Active', Validators.required],

      isPushedOnLvs: [this.isPushedOnLvs ? true : false]


    });

  }


  updatemyMatchStatus(id:any) {
    this.metaDataService.updateMatchStatus(id).subscribe({
     next: (res: any) => {
        if (res && res.success) {
          // this.response.emit(res);
          this.dialogRef.close({ success: true });
        } else {
          this.commonService.showError('', res.message);
        }
      },
     error: (err) => {
        this.commonService.showError('', err.error ? err.error.message : err);
      }
  });
  }




}